export default "__VITE_ASSET__C7Xq7LCm__"